import Model from './Model'
import TalentCandidate from "./TalentCandidate";
import UserDiscipline from "./UserDiscipline";

const LOOKUP = {
    "favorites": -1,
    "past-hires": -2,
    "bring-your-own-talent": -3,
    "blocked-talent": -10,
}
export default class TalentPool extends Model
{
	static Key = 'TalentPool';

    static favoritedPoolId = LOOKUP['favorites']
    static pastHiresPoolId = LOOKUP['past-hires']
    static talentInvitesPoolId = LOOKUP['bring-your-own-talent']
    static blockedTalentPoolId = LOOKUP['blocked-talent']

    static restrictedPoolNames = [
        'wripple recommended',
        'favorites',
        'past hires',
        'talent invitations',
        'blocked talent'
    ]
    static normalize(props)
    {
        if (props.pool_disciplines) {
            let poolDisciplineIds = TB.keys(props.pool_disciplines);
            let disciplines = TB.filter(TB.flatMap(laravel.discipline_categories, 'disciplines'), dis => {
                return poolDisciplineIds.includes(String(dis.id))
            })
            disciplines = TB.map(disciplines, dis => {
                return {
                    ...dis,
                    talent_users: props.pool_disciplines[String(dis.id)]
                }
            })
            props.talent_disciplines = disciplines;
        }
        return props;
    }

    static async createTalentPool(props) {
        const auth = TB.auth().user();

        const createTalentPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${auth.clientOrg().id}/talent-pools/create`), {...props}
        );

        let response = await createTalentPoolRequest.post().catch(e => console.warn(e));

        if (!response || !TB.has(response, 'success.data.client_talent_pool')) {
            return;
        }

        return TalentPool.make(response.success.data.client_talent_pool)
    }

    static async updateTalentPool(talentPoolId, props) {
        const auth = TB.auth().user();

        const updateTalentPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${auth.clientOrg().id}/talent-pools/${talentPoolId}/update`), {...props}
        );

        let response = await updateTalentPoolRequest.post().catch(e => console.warn(e));

        if (!response || !TB.has(response, 'success.data.client_talent_pool')) {
            return;
        }

        return TalentPool.make(response.success.data.client_talent_pool)
    }

    static async deleteTalentPool(talentPoolId, props) {
        const auth = TB.auth().user();

        const deleteTalentPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${auth.clientOrg().id}/talent-pools/${talentPoolId}/delete`), {...props}
        );

        let response = await deleteTalentPoolRequest.post().catch(e => console.warn(e));

        if (!response || !TB.has(response, 'success.data')) {
            return;
        }

        return response.success.data
    }

    static onFavoriteUpdated (talentId, isFavorite) {
        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'searchForTalent' || (queryKey?.[0] === 'fetchTalentPoolDetail');
            }
        }, page => {
            if(!page) return page;
            if (page.users) {
                let users = TB.map([...(page.users || [])], talent => {
                    if (talent.id === talentId) {
                        return TalentCandidate.make({...talent, is_favorite: isFavorite});
                    }
                    return talent;
                });

                return {...page, users}
            }
            if (page.talent_users) {
                let talent_users = TB.map([...(page.talent_users || [])], talent => {

                    if (talent.id === talentId) {

                        return TalentCandidate.make({...talent, is_favorite: isFavorite});
                    }
                    return talent;
                });
                let updatedPage = TalentPool.make({...page, talent_users});

                if (page.id === LOOKUP["favorites"]) {
                    updatedPage.talent_users = TB.filter(talent_users, ['is_favorite', true])

                    updatedPage.total = updatedPage.total + (isFavorite ? 1 : -1);
                    updatedPage.last_page = Math.ceil(updatedPage.total / 12);
                    if (updatedPage.talent_users?.length === 0) {
                        TB.queryClient.invalidateQueries({predicate: ({queryKey}) => (queryKey[0] === 'fetchTalentPoolDetail')});
                    }
                }
                return TalentPool.make(updatedPage)
            }

            return page;
        });
        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                return queryKey?.[0] === 'fetchTalentPools'
            }
        }, pools => {
            if (!pools || !pools?.length) return;

            return TB.map([...pools], pool => {
                if (pool.id === LOOKUP['favorites']) {


                    return this.make({...pool, talent_users_count: (pool.talent_users_count || 0) + (isFavorite ? 1 : -1)})
                }

                return this.make(pool);
            });
        });
    }
    static onTalentUpdated (updatedTalent) {
        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'searchForTalent' || (queryKey?.[0] === 'fetchTalentPoolDetail');
            }
        }, page => {
            if(!page) return page;
            if (page.users) {
                let users = TB.map([...(page.users || [])], talent => {
                    if (talent.id === updatedTalent?.id) {
                        return updatedTalent;
                    }
                    return talent;
                });

                return {...page, users}
            }
            if (page.talent_users) {
                let talent_users = TB.map([...(page.talent_users || [])], talent => {

                    if (talent.id === updatedTalent?.id) {

                        return updatedTalent;
                    }
                    return talent;
                });
                return this.make({...page, talent_users})
            }

            return page;
        });
    }


    static refreshTalentPoolMember (updatedTalent, poolId) {
        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'searchForTalent' || (queryKey?.[0] === 'fetchTalentPoolDetail' && parseInt(params?.poolId) === parseInt(poolId));
            }
        }, page => {
            if(!page) return page;
            if (page.users) {
                let users = TB.map([...(page.users || [])], talent => {
                    if (talent.id === updatedTalent.id) {
                        return TalentCandidate.make({...talent, ...updatedTalent});
                    }
                    return talent;
                });
                return {...page, users}
            }
            if (page.talent_users) {
                let talent_users = TB.map([...(page.talent_users || [])], talent => {

                    if (talent.id === updatedTalent.id) {

                        return TalentCandidate.make({...talent, ...updatedTalent});
                    }
                    return talent;
                });
                return this.make({...page, talent_users})
            }

            return page;
        });
    }

    static resetTalentMemberDataForPool = async (talentPoolId) => {
        await TB.queryClient.invalidateQueries({predicate: ({queryKey}) => {
            return queryKey[0] === 'fetchTalentPools'
        }})
        return TB.queryClient.invalidateQueries({predicate: ({queryKey}) => {
                return queryKey[0] === 'fetchTalentPoolDetail' && parseInt(queryKey[1]?.poolId) === parseInt(talentPoolId)
            }})
    }

    /*
    * Helper methods
    */
    isWrippleRecommendedPool() {
        return this.name === 'Wripple Recommended'
    }

    isTalentInvitePool() {
        return TB.invert(LOOKUP)[this.id] === 'bring-your-own-talent'
    }
    isFavoritesPool() {
        return TB.invert(LOOKUP)[this.id] === 'past-hires'
    }
    isPastHirePool() {
        return TB.invert(LOOKUP)[this.id] === 'favorites'
    }
    isBlockedTalentPool() {
        return TB.invert(LOOKUP)[this.id] === 'blocked-talent'
    }

    canBeEdited() {
        let auth = TB.auth().user();
        return !this.isFavoritesPool() && !this.isPastHirePool() && !this.isBlockedTalentPool() && (auth?.canManageClients() || !this.isWrippleRecommendedPool())
    }


    canAddRemoveTalent() {
        let auth = TB.auth().user();
        return !this.isFavoritesPool() && !this.isPastHirePool() && (auth?.canManageClients() || !this.isWrippleRecommendedPool())
    }

    isVisible() {
        if (this.is_default) {

            return !this.isWrippleRecommendedPool() || (this.talent_users_count > 0 || this.canAddRemoveTalent());
        }
        return true
    }

    defaultSearchParams() {
        let acceptedParams = {
            'disciplines': (ids) => TB.filter(ids, id => TB.isInteger(id)),
            'important_skills': (ids) => TB.filter(ids, id => TB.isInteger(id)),
            'nice_to_have_skills': (ids) => TB.filter(ids, id => TB.isInteger(id)),
            'very_important_skills': (ids) => TB.filter(ids, id => TB.isInteger(id)),
            'important_industries': (ids) => TB.filter(ids, id => TB.isInteger(id)),
            'nice_to_have_industries': (ids) => TB.filter(ids, id => TB.isInteger(id)),
            'very_important_industries': (ids) => TB.filter(ids, id => TB.isInteger(id)),
            'location': (id) => TB.keys(TB.invert(laravel.project_visibility_location_settings)).includes(parseInt(id)),
            'latitude': (lat) => !TB.isNaN(parseFloat(lat)),
            'longitude': (lng) => !TB.isNaN(parseFloat(lng)),
            'experience': (ids) => TB.filter(ids, id => TB.isInteger(id)),
            'hired': value => TB.isBoolean(parseInt(value)),
            'favorited': value => TB.isBoolean(parseInt(value)),
            'invited': value => TB.isBoolean(parseInt(value)),
            'pool_ids': value => TB.isArray(value) && TB.filter(value, id => TB.isInteger(id)),
        };

        let params = TB.storedBrowseFilters('talentPool-' + this.id);
        if(!params) {
            return {}
        }
        let accepted = {
            favorited: 0,
            invited: 0,
            hired: 0,
            categories: [],
            project_templates: [],
            disciplines: [],
            address: null,
            latitude: null,
            longitude: null,
            experience: {
                junior: false,
                intermediate: false,
                senior: false,
            },
            location: TB.locationGlobalSetting(),
            industries: [],
            skills: [],
            pool_ids: [],
            regions: [],
            brands: [],
            custom: {}
        };

        let customFilters = {};
        if (params['custom']) {
            try {
                customFilters = params['custom'] ? JSON.parse(params['custom']) : []
            }catch (e) {
                console.warn(e)
            }
        }



        const disciplineCategories = TB.map([...laravel.discipline_categories], cat => {
            let option = TB.pick(cat, ['id', 'name', 'disciplines', 'display_order'])
            let disciplines = option.disciplines;//TB.filter(option.disciplines, ['is_contractable', true]);

            option.disciplines = TB.map(disciplines, discipline => TB.pick(discipline, ['id', 'name', 'display_order']))
            option.value = option.id;

            return option
        });

// console.log(disciplineCategories, 'DISPLICE CATS')

        const disciplines = TB.map(disciplineCategories, category => {
            return {
                ...category,
                options: category.disciplines.map(discipline => {
                    return {
                        ...discipline,
                        value: discipline.id
                    }
                })
            }
        })
        const industries = TB.map(laravel.client_industries, (name, value) => {
            return { name, value: Number(value), id: Number(value) }
        });
        try {
            TB.map(params, (value, key) => {

                if (accepted.hasOwnProperty(key) || key.includes('skills') || key.includes('industries')) {
                    if (key.includes('disciplines')) {
                        let roleIds = JSON.parse(value) || [];

                        roleIds = TB.filter(roleIds, role => !TB.isNaN(parseInt(role)))
                        let roles = TB.filter(TB.flatMap(disciplines, 'options'), dis => roleIds.includes(dis.id));
                        accepted.disciplines = TB.uniqBy([
                            ...(accepted.disciplines || []),
                            ...roles
                        ], 'id');
                    }else if (key.includes('skills')) {
                        let skillIds = JSON.parse(value) || [];
                        skillIds = TB.filter(skillIds, skill => !TB.isNaN(parseInt(skill)))
                        const skillsByRole = UserDiscipline.skillsForDisciplines(TB.map(TB.flatMap(disciplines, 'options'), 'id')) || [];
                        const customSkills = TB.isArray(customFilters?.skills) ? customFilters?.skills : [];
                        let skills = TB.filter([...(skillsByRole || []), ...(customSkills || [])], skill => skillIds.includes(skill.id));
                        let scorePrefix = TB.replace(key, '_skills', '');
                        let importance = 1;
                        switch (scorePrefix) {
                            case 'nice_to_have':
                                importance = 1;
                                break;
                            case 'important':
                                importance = 2;
                                break;
                            case 'very_important':
                                importance = 3;
                                break;
                        }
                        skills = TB.map(skills, skill => ({...skill, value: skill?.id, importance}))

                        accepted[`skills`] = TB.uniqBy([
                            ...(accepted[`skills`] || []),
                            ...skills
                        ], 'id')

                    }else if (key.includes('industries')) {
                        let industriesIds = JSON.parse(value) || [];

                        industriesIds = TB.filter(industriesIds, industry => !TB.isNaN(parseInt(industry)))
                        const customIndustries = TB.isArray(customFilters?.industries) ? customFilters?.industries : [];

                        let industriesSearch = TB.filter([...industries, ...(customIndustries || [])], industry => industriesIds.includes(industry.id));
                        let scorePrefix = TB.replace(key, '_industries', '');

                        let importance = 1;
                        switch (scorePrefix) {
                            case 'nice_to_have':
                                importance = 1;
                                break;
                            case 'important':
                                importance = 2;
                                break;
                            case 'very_important':
                                importance = 3;
                                break;
                        }
                        industriesSearch = TB.map(industriesSearch, industry => ({...industry, value: industry.id,  importance}))
                        accepted[`industries`] = TB.uniqBy([
                            ...(accepted[`industries`] || []),
                            ...industriesSearch
                        ], 'id')
                    }

                    if (key === 'experience') {
                        try {
                            accepted['experience'] = JSON.parse(value);
                        }catch (e) {
                            console.warn('jsonError', e)
                        }
                    }

                    if (key === 'hired') {
                        accepted.hired = JSON.parse(value)
                    }

                    if (key === 'favorited') {
                        accepted.favorited = JSON.parse(value)
                    }
                    if (key === 'invited') {
                        accepted.invited = JSON.parse(value)
                    }
                    if (key === 'pool_ids') {
                        accepted.pool_ids = JSON.parse(value)

                        accepted.pool_ids = TB.filter(accepted.pool_ids, pool => !TB.isNaN(parseInt(pool)))
                    }
                    if (key === 'brands') {
                        accepted.brands = JSON.parse(value)

                        accepted.brands = TB.filter(accepted.brands, brandID => !TB.isNaN(parseInt(brandID)))
                    }

                    if (key === 'location' && !TB.isNaN(parseInt(JSON.parse(value)))) {
                        accepted.location = parseInt(JSON.parse(value))
                    }
                    if (key === 'address') {
                        accepted.address = value
                    }
                    if (key === 'regions') {
                        accepted.regions = JSON.parse(value)

                        accepted.regions = TB.filter(accepted.regions, regionId => !TB.isNaN(parseInt(regionId)))
                    }
                    if (key === 'latitude' && !TB.isNaN(parseFloat(JSON.parse(value)))) {
                        accepted.latitude = parseFloat(JSON.parse(value))
                    }
                    if (key === 'longitude' && !TB.isNaN(parseFloat(JSON.parse(value)))) {
                        accepted.longitude = parseFloat(JSON.parse(value))
                    }

                    if (key === 'custom') {
                        let customSearchParams = JSON.parse(value);
                        if (customSearchParams.skills || customSearchParams.industries) {
                            accepted.skills = TB.uniqBy([
                                ...accepted.skills,
                                ...customSearchParams.skills || []
                            ], 'id');
                            accepted.industries = TB.uniqBy([
                                ...accepted.industries,
                                ...(customSearchParams.industries || [])
                            ], 'id');
                            accepted.custom = {
                                skillOptions: customSearchParams.skills || [],
                                industryOptions: customSearchParams.industries || []
                            }
                        }
                    }
                }
            })
        }catch (e) {
            console.error('JSON PARSE ERROR', e)
            TB.persistStoredBrowseFilters('talentPool' + this.id, {});
        }
        return accepted;
    }
}